import type { ComplaintDto } from "@/api/complaints.api";
import type { ContributionTaskKey } from "./task-registry";

export interface TaskReportInput {
  task: ContributionTaskKey;
  /** Task name as shown to the person, e.g. "Enregistrer". */
  taskLabel: string;
  reason: string;
  details?: string;
  /** Route of the task page, e.g. "/fr/speak-contribute". */
  page: string;
  /** Id of the phrase or audio on screen, when there is one. */
  itemId?: string | null;
  /** Localised "item {id}" fragment, already filled. */
  itemLabel?: string;
}

/**
 * The complaint sent by the "Signaler" pill: same pipeline as the contact
 * form (type "bug"), stamped with the task page and the item id so the admin
 * Réclamations list can find the phrase or audio in question.
 */
export function buildTaskReport({ task, taskLabel, reason, details, page, itemId, itemLabel }: TaskReportInput): ComplaintDto {
  const id = itemId ? String(itemId).trim() : "";
  const message = [`[${taskLabel}] ${reason}`, details?.trim() ?? "", id ? `(${itemLabel ?? id})` : ""]
    .filter(Boolean)
    .join(" - ");
  return {
    type: "bug",
    message,
    page,
    ...(id ? { collectionContext: `${task}:${id}` } : {}),
  };
}
